document.addEventListener("DOMContentLoaded", () => {
  const targets = Array.from(document.querySelectorAll(".reveal"));
  if (!targets.length) return;

  // Helper: is element visibly within viewport (some overlap)
  const inView = (el, margin = 0) => {
    const r = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const vw = window.innerWidth || document.documentElement.clientWidth;
    return (
      r.bottom > margin &&
      r.right > margin &&
      r.top < vh - margin &&
      r.left < vw - margin
    );
  };

  // Track scroll direction
  let lastY = window.pageYOffset || document.documentElement.scrollTop;
  let ticking = false;

  const run = () => {
    const y = window.pageYOffset || document.documentElement.scrollTop;
    const dir = y > lastY ? "down" : y < lastY ? "up" : "still";
    lastY = y;

    // Apply based on direction while element is visible
    targets.forEach(el => {
      if (!inView(el, 20)) return; // only react while on screen
      if (dir === "down") {
        el.classList.add("in-view");
      } else if (dir === "up") {
        el.classList.remove("in-view");
      }
    });

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(run);
      ticking = true;
    }
  };

  // Initial state: ensure items start hidden until user scrolls
  targets.forEach(el => el.classList.remove("in-view"));

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
});
